import React from 'react';
import Link from 'Components/Link';

import LoadingAnimation from 'Components/LoadingAnimation';
import styles from './Button.scss';
import CaretRightIcon from './caret-right.svg';
import CaretRightSmallIcon from './caret-right-small.svg';

class Button extends React.PureComponent {
  constructor(props) {
    super(props);

    this.ctaIcons = (icon, type) => {
      const iconProps = {
        className: 'Button__cta-icon',
        'data-type': icon,
      };
      switch (icon) {
        case 'caret':
          return type === 'primary' ? (
            <CaretRightIcon {...iconProps} />
          ) : (
            <CaretRightSmallIcon {...iconProps} />
          );
          break;
        default:
          try {
            const CTAIcon = require(`./${icon}.svg`);
            return <CTAIcon {...iconProps} />;
          } catch (e) {
            return null;
          }
      }
    };
  }

  render() {
    const {
      buttonType,
      externalLink,
      route,
      clickHandler,
      noLink,
      disabled,
      loading,
      label,
      labelExtension,
      additionalClasses,
      newWindow,
      ctaIcon,
      ctaIconBefore,
      isSubmit,
      blurOnClick,
      style,
    } = this.props;

    const typeClass = buttonType ? ` Button--${buttonType}` : '';
    const combinedLabel = (
      <span className="Button__label">
        {label}
        {labelExtension ? (
          <span className="Button__label--extension"> {labelExtension}</span>
        ) : null}
      </span>
    );

    if (isSubmit) {
      const isAddUser = buttonType === 'add-user';
      const submitClass = isAddUser ? ' Button--secondary-mono' : typeClass;
      return (
        <button
          type="submit"
          className={`Button ${submitClass} ${additionalClasses || ''}${
            loading ? ' Button--loading' : ''
          }`}
          disabled={disabled}
          style={style}
        >
          {combinedLabel}
          {isAddUser ? this.ctaIcons('return') : null}
          {loading ? <LoadingAnimation size="small" type="button" /> : null}
        </button>
      );
    }

    if (buttonType === 'add-user') {
      return (
        <button
          type="submit"
          className={`Button Button--secondary-mono ${additionalClasses || ''}${
            loading ? ' Button--loading' : ''
          }`}
          disabled={disabled}
          style={style}
        >
          {combinedLabel}
          {this.ctaIcons('return')}
          {loading ? <LoadingAnimation size="small" type="button" /> : null}
        </button>
      );
    }
    const icon = ctaIcon ? this.ctaIcons(ctaIcon) : null;
    let classes = `${typeClass}${additionalClasses || ''}${
      ctaIconBefore ? ' Button--flip-order' : ''
    }`;
    if (externalLink) {
      return (
        <a
          href={externalLink}
          target={newWindow ? '_blank' : null}
          className={`Button${classes}`}
          style={style}
        >
          {combinedLabel}
          {icon}
        </a>
      );
    } else if (noLink) {
      return (
        <div className={`Button${classes} Button--static`} style={style}>
          {combinedLabel}
          {icon}
        </div>
      );
    } else if (clickHandler) {
      return (
        <button
          ref={button => (this.buttonEl = button)}
          className={`Button${classes}`}
          onClick={e => {
            if (this.buttonEl && blurOnClick) this.buttonEl.blur();
            return clickHandler(e);
          }}
          style={style}
        >
          {combinedLabel}
          {icon}
        </button>
      );
    }
    return (
      <Link
        to={route}
        className={`Button${classes}`}
        activeClassName="is-active"
        onClick={e => {
          if (clickHandler) return clickHandler(e);
        }}
        style={style}
      >
        {combinedLabel}
        {icon}
      </Link>
    );
  }
}

export default Button;
